import { InjectionToken } from "@angular/core";

export const BASE_BACKEND_URL = new InjectionToken<string>('BASE_URL');
export const SETTINGS_CONTEXT = new InjectionToken<string>('SETTINGS_CONTEXT');
